export const color = {
  white: '#fff',
  black: '#1A1919',
  lightBlack: '#111B40',
  darkerGrey: '#565656',
  grey: '#8F8F8F',
  lightGrey: '#C4C4C4',
  lighterGrey: '#CCCCCC',
  blue: '#304CB2',
  darkerBlue: '#1C4486',
  clusterBlue: '#1a2c80',
  yellow: '#FFBF27',
  orange: '#ff792e',
} as const;

export const defaultCssProps = {
  borderRadius: {
    xSmall: '0.0625rem',
    small: '0.125rem',
    normal: '0.25rem',
  },
} as const;

/* styled-components theme */
export const theme = {
  color,
  defaultCssProps,
} as const;

export type ThemeType = typeof theme;
export type ColorType = ThemeType['color'][keyof ThemeType['color']];

// Overwrite styled-components DefaultTheme
declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface DefaultTheme extends ThemeType {}
}
